import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import enTranslations from "./locales/en.json"
import siTranslations from "./locales/si.json"
import taTranslations from "./locales/ta.json"

const resources = {
  en: { translation: enTranslations },
  si: { translation: siTranslations },
  ta: { translation: taTranslations },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
